import React, { Fragment } from 'react';
import { Intro, SliderGroup, Voiceover } from 'dea-core';
import img1 from '../../assets/images/U1-T1-10A.svg';
import img2 from '../../assets/images/U1-T1-10B.svg';
import img3 from '../../assets/images/U1-T1-10C.svg';
import img4 from '../../assets/images/U1-T1-10D.svg';
import img5 from '../../assets/images/U1-T1-10E.svg';
import voAudio from '../../assets/vo/Opioid-M-One-11-NEW-mod.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <Fragment>
      <p>
        Often, when we think of the opioid epidemic, we think we are safe
        because we don’t use heroin or illicit fentanyl. But from what we know
        about how prescription misuse works, we can all become susceptible.
      </p>
      <p>
        Answer the following questions to reflect on your relationship with
        prescription medication in general and prescription opioids
        specifically.
      </p>
    </Fragment>
  )
};

const options = [
  {
    label: 'Always',
    value: 'Always'
  },
  {
    label: 'Sometimes',
    value: 'Sometimes'
  },
  {
    label: 'Never',
    value: 'Never'
  }
];

const data = {
  questions: [
    {
      question:
        'How often do you take over-the-counter medication exactly as directed?',
      image: img1,
      imageAltText: '',
      options
    },
    {
      question:
        'How often do you take prescription medications exactly as directed?',
      image: img2,
      imageAltText: '',
      options
    },
    {
      question:
        'How often do you take unused and/or expired medication to an official disposal site?',
      image: img3,
      imageAltText: '',
      options
    },
    {
      question:
        'How often do you follow up with family and friends who have been prescribed opioids on how they are feeling after the prescription runs out?',
      image: img4,
      imageAltText: '',
      options
    },
    {
      question:
        'How often do you get prescribed opioids from a doctor for pain not associated with cancer, kidney stones, or other excruciating physical trauma?',
      image: img5,
      imageAltText: '',
      options
    }
  ]
};

const feedback = {
  success: {
    title: '',
    body:
      'Not only is it important to take all over-the-counter and prescription medication as directed, but it is also important to check up on family and friends who have been prescribed opioids. Ask yourself if something as strong as an opioid is really necessary for what you’re dealing with, and ask family or friends who have been prescribed opioids the same question. And, remember to dispose of unused or expired medications, especially prescription opioids. These are primary prevention methods.'
  }
};

export default {
  title: 'How Often do You...',
  path: '/elaborate/how-often-do-you',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="How often do you…"
        lead="Take a moment to reflect on your relationship with prescriptions."
        direction="Drag the slider to answer the question."
      />
      <SliderGroup feedback={feedback} data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/HowOftenDoYou.js